import { Stack } from "@mui/material";
import { NotificationType } from "constants/NotificationConstants";
import { NotificationResource } from "models/Resources/NotificationResource";
import { useState } from "react";
import Notification from "../Notifications";
import "./NotificationList.scss";

type Props = {
  title: string;
  notifications: NotificationResource[];
  handleNotificationClick: (
    type: NotificationType,
    notificationId: string
  ) => void;
};

const NotificationListSection: React.FC<Props> = ({
  title,
  notifications,
  handleNotificationClick,
}: Props) => {
  const [isSectionExpanded, setSectionExpanded] = useState(true);

  return (
    <Stack className={`${title}-notification-section`}>
      <div
        onClick={() => setSectionExpanded(!isSectionExpanded)}
        className="notification-list-section-title">
        {title}
      </div>
      {isSectionExpanded ? (
        notifications.length > 0 ? (
          notifications?.map(notification => (
            <Notification
              key={notification.notificationId}
              notificationId={notification.notificationId}
              handleNotificationDetailClick={() =>
                handleNotificationClick(
                  notification.type,
                  notification.notificationId
                )
              }
            />
          ))
        ) : (
          <Stack className="notifications-empty-body">
            Aucunes notifications
          </Stack>
        )
      ) : null}
    </Stack>
  );
};
export default NotificationListSection;
